import { Injectable } from '@angular/core';
import { SessionStorageService } from './storage.service';

export const ROLES_PERMISSIONS = {
	MesTeamManager: [
		'mes:EmployeeGet',
		'mes:EmployeeReadById',
		'mes:EmployeeReadByKey',
		'mes:CalendarGet',
		'mes:AppointmentGet',
		'mes:AppointmentCreate',
		'mes:AppointmentUpdate',
		'mes:AppointmentDelete',
		'mes:WorkTaskGet',
		'mes:WorkTaskReadById',
		'mes:WorkTaskReadByAlias',
		'mes:TeamProfileGet',
		'mes:TeamProfileGetById',
		'mes:TeamProfileGetByAlias',
		'mes:ShiftGet',
		'mes:ShiftCreate',
		'mes:ShiftUpdate',
		'mes:ShiftDelete',
		'mes:DepartmentGet',
		'mes:DepartmentCreate',
		'mes:DepartmentUpdate',
		'mes:EmployeeNoteGet',
		'mes:EmployeeNoteCreate',
		'mes:EmployeeNoteUpdate',
		'mes:EmployeeNoteDelete',
	],
	MesManager: [
		'mes:EmployeeStampIn',
		'mes:EmployeeStampOut',
		'mes:EmployeeGet',
		'mes:EmployeeReadById',
		'mes:EmployeeReadByKey',
		'mes:EmployeeCreate',
		'mes:EmployeeUpdate',
		'mes:EmployeeDelete',
		'mes:EmployeeGetFavouriteTasks',
		'mes:EmployeeGetActiveWorkTask',
		'mes:CalendarGet',
		'mes:CalendarCreate',
		'mes:CalendarUpdate',
		'mes:CalendarDelete',
		'mes:AppointmentGet',
		'mes:AppointmentCreate',
		'mes:AppointmentUpdate',
		'mes:AppointmentDelete',
		'mes:WorkTaskGet',
		'mes:WorkTaskReadById',
		'mes:WorkTaskReadByAlias',
		'mes:WorkTaskCreate',
		'mes:WorkTaskUpdate',
		'mes:WorkTaskDelete',
		'mes:TeamProfileCreate',
		'mes:TeamProfileGet',
		'mes:TeamProfileGetById',
		'mes:TeamProfileGetByAlias',
		'mes:TeamProfileUpdate',
		'mes:TerminalCreate',
		'mes:TerminalGet',
		'mes:TerminalUpdate',
		'mes:TerminalDelete',
		'mes:BatchCreate',
		'mes:BatchGet',
		'mes:BatchUpdate',
		'mes:BatchDelete',
		'mes:ShiftGet',
		'mes:ShiftCreate',
		'mes:ShiftUpdate',
		'mes:ShiftDelete',
		'mes:ItemOperationGet',
		'mes:ItemOperationCreate',
		'mes:ItemOperationUpdate',
		'mes:ItemOperationDelete',
		'mes:UnapprovedTimestampsGet',
		'mes:ActiveEmployeesWithoutTimestampsGet',
		'mes:DatesWithUnapprovedTimestampsGet',
		'mes:ApproveValidTimestampsOnDateForEmployee',
		'mes:ApproveValidTimestampsOnDate',
		'mes:WorkCenterCreate',
		'mes:WorkCenterGet',
		'mes:WorkCenterUpdate',
		'mes:WorkCenterDelete',
		'mes:DepartmentGet',
		'mes:DepartmentCreate',
		'mes:DepartmentUpdate',
		'mes:EmployeeNoteGet',
		'mes:EmployeeNoteCreate',
		'mes:EmployeeNoteUpdate',
		'mes:EmployeeNoteDelete',
	],
} as const;

@Injectable({
	providedIn: 'root',
})
export class UserRoleService {
	private userRoles: Set<string> = new Set();

	constructor(private sessionStorageService: SessionStorageService) {
		this.recomputeRoles();
		this.sessionStorageService.watch('User.Permissions').subscribe(() => {
			this.recomputeRoles();
		});
	}

	private recomputeRoles(): void {
		const userPermissions = new Set(JSON.parse(this.sessionStorageService.get('User.Permissions')) ?? []);
		const allRoles = Object.keys(ROLES_PERMISSIONS) as (keyof typeof ROLES_PERMISSIONS)[];
		this.userRoles = new Set(
			allRoles.filter((role) => {
				if (!ROLES_PERMISSIONS[role]) return false;
				return ROLES_PERMISSIONS[role].every((perm) => userPermissions.has(perm));
			}),
		);
	}

	public userHasRole(role: keyof typeof ROLES_PERMISSIONS): boolean {
		return this.userRoles.has(role);
	}
}
